import React from "react";
import { withRouter } from "react-router-dom";
import ReactDOM from "react-dom";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Layout from "../layouts/Layout";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import Moment from "moment";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { primaryShade1, red, white } from "../styles/color";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import FormControl from "@material-ui/core/FormControl";

const variantIcon = {
  warning: WarningIcon
};

const styles1 = theme => ({
  warning: {
    backgroundColor: theme.palette.error.dark
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["warning"]).isRequired
};

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);
const stylesMain = theme => ({
  margin: {
    margin: "8px"
  },
  textField: {
    flexBasis: 200
  }
});
const ITEM_HEIGHT = 45;
const ITEM_PADDING_TOP = 10;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4 + ITEM_PADDING_TOP
    }
  }
};
class GenerateInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      month: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      currentMonth: "",
      date: new Date(),
      currentDate: "",
      checkboxChecked: null,
      selectedDeals: [],
      selectedDealsDetails: [],
      selectedDealsCount: 0,
      totalBrokerageAmount: 0,
      amount: null,
      totalQuantity: 0,
      description: "",
      SelectedCustomerList: [],
      selectValue: [],
      checkedItems: [],
      selectedDealsId: [],
      otherPartyId: [],
      customerName: null,
      currentBrokerage: 0,
      counter: 0,
      openSnackBar: false,
      availabilityMessage: null,
      isError: null,
      invoiceAlreadyExist: [],
      snackbarMessage: [],
      invoiceNumber: "",
      labelWidth: 0
    };
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };
  handleInvoiceNumberChange = name => event => {
    this.setState({ [name]: event.target.value });
    let tempInvoices = this.props.allInvoices.filter(
      invoiceNumber => invoiceNumber.invoiceNumber === event.target.value
    );
    this.setState({ invoiceAlreadyExist: tempInvoices });
    if (tempInvoices.length > 0) {
      let availabilityMessage = "This Invoice Number Already Exist...!";
      this.setState({ availabilityMessage });
      this.setState({ isError: "error" });
    } else {
      let availabilityMessage = " ";
      this.setState({ availabilityMessage });
      this.setState({ isError: "" });
    }
  };
  handleChangeSelected = event => {
    this.setState({
      selectedDeals: event.target.value
    });
  };
  handleSelectedCount = () => {
    this.setState({ selectedDealsCount: this.state.selectedDeals.length });
    let selectedDealsDetails = [];
    this.state.selectedDeals.map(id => {
      return selectedDealsDetails.push(
        this.props.customersList.find(data => data.id === id)
      );
    });
    this.handleCalculateBrokerage(selectedDealsDetails);
  };
  handleCalculateBrokerage = dealsBrokerageDetails => {
    let totalBrokerage = 0;
    let selectedDealsId = [];
    let otherPartyId = [];
    let totalQuantity = 0;
    dealsBrokerageDetails.map(data => {
      totalBrokerage += parseInt(data.brokerage) * parseInt(data.quantity);
      selectedDealsId.push(data.id);
      otherPartyId.push(data.customerId);
      totalQuantity += parseInt(data.quantity);
      return { totalBrokerage, selectedDealsId, otherPartyId, totalQuantity };
    });
    this.setState({
      totalBrokerageAmount: totalBrokerage,
      selectedDealsId,
      otherPartyId,
      totalQuantity
    });
  };
  handleDateChange = name => event => {
    this.setState({ [name]: new Date(event.target.value) });
  };
  handleRateChange = name => event => {
    this.setState({ [name]: event.target.value });
    this.calculateBrokerage(event.target.value);
  };

  handleOpenSnackBar = snackbarMessage => {
    this.setState({ openSnackBar: true, snackbarMessage });
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({ openSnackBar: false });
  };

  componentDidMount() {
    this.setState({
      labelWidth: ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth
    });
  }
  render() {
    console.log(this.state.date);
    const {
      customersList,
      isLoading,
      generateInvoice,
      user,
      selectedCustomerName,
      classes,
      organisationId
    } = this.props;
    const {
      availabilityMessage,
      selectedDeals,
      selectedDealsCount,
      totalBrokerageAmount,
      invoiceAlreadyExist,
      snackbarMessage,
      date,
      labelWidth
    } = this.state;
    return (
      <Layout
        position="static"
        appBar
        appBarTitle={"GENERATE INVOICE"}
        appBarLeftIcon={true}
      >
        {isLoading === false ? (
          <h3>Wait</h3>
        ) : (
          <div
            style={{
              top: "66px",
              position: "absolute",
              width: "100vw",
              height: "calc(100vh - 66px)",
              display: "flex",
              flexDirection: "column"
            }}
          >
            {" "}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "calc(100vh - 122px)",
                overflowY: "scroll"
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    borderRadius: "15px"
                  }}
                >
                  <TextField
                    style={{ flex: 2.5 }}
                    id="outlined-bare"
                    type="date"
                    defaultValue={Moment(date).format("YYYY-MM-DD")}
                    className={classNames(classes.margin)}
                    onChange={this.handleDateChange("date")}
                    variant="outlined"
                    label="Date"
                    InputLabelProps={{
                      shrink: true
                    }}
                    margin="normal"
                    required={true}
                  />
                  <TextField
                    style={{ flex: 2.5 }}
                    required={true}
                    id="outlined-bare"
                    name="text"
                    type="text"
                    InputLabelProps={{
                      shrink: true
                    }}
                    label="Invoice Number"
                    className={classNames(classes.margin)}
                    onChange={this.handleInvoiceNumberChange("invoiceNumber")}
                    variant="outlined"
                    backgroundColor={
                      availabilityMessage !== "" ? red : primaryShade1
                    }
                  />
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                {availabilityMessage !== "" ? (
                  <div
                    style={{
                      textAlign: "right"
                    }}
                  >
                    <span style={{ color: red, fontSize: "13px" }}>
                      {availabilityMessage}
                    </span>
                  </div>
                ) : (
                  ""
                )}{" "}
              </div>{" "}
              <FormControl
                variant="outlined"
                className={classNames(classes.margin)}
              >
                <InputLabel
                  ref={ref => {
                    this.InputLabelRef = ref;
                  }}
                  htmlFor="select-multiple"
                >
                  Select Deals
                </InputLabel>
                <Select
                  multiple
                  label="Select Deals"
                  required={true}
                  value={selectedDeals}
                  MenuProps={MenuProps}
                  style={{
                    autoWidth: "true"
                  }}
                  onChange={e => {
                    e.preventDefault();
                    this.handleChangeSelected(e);
                  }}
                  onBlurCapture={e => this.handleSelectedCount()}
                  input={
                    <OutlinedInput
                      name="selectDeals"
                      id="select-multiple"
                      labelWidth={labelWidth}
                    />
                  }
                >
                  <MenuItem value="Select" disabled>
                    Select
                  </MenuItem>

                  {customersList.map((name, index) => (
                    <MenuItem key={name} value={name.id} id={index}>
                      {name.customerName +
                        " (" +
                        name.products +
                        ") " +
                        name.typeOfRate}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    borderRadius: "15px"
                  }}
                >
                  <TextField
                    style={{ flex: 2 }}
                    className={classNames(classes.margin)}
                    id="outlined-bare"
                    name="text"
                    type="number"
                    label="Selected Deals"
                    value={selectedDealsCount}
                    onChange={this.handleChange("amount")}
                    variant="outlined"
                    inputProps={{ style: { color: primaryShade1 } }}
                    required={true}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />

                  <TextField
                    style={{ flex: 2 }}
                    className={classNames(classes.margin)}
                    placeholder="Amount"
                    id="outlined-bare"
                    name="text"
                    type="number"
                    label="Invoice Amount"
                    value={totalBrokerageAmount}
                    variant="outlined"
                    inputProps={{ style: { color: primaryShade1 } }}
                  />
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <TextField
                  style={{ flex: 1 }}
                  className={classNames(classes.margin)}
                  name="description"
                  label="Description"
                  multiline
                  rows="4"
                  rowsMax="4"
                  onChange={this.handleChange("description")}
                  InputLabelProps={{
                    shrink: true
                  }}
                  variant="outlined"
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "56px",
                position: "absolute",
                bottom: "0px",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Button
                disabled={invoiceAlreadyExist.length > 0 ? true : false}
                variant="contained"
                onClick={e => {
                  e.preventDefault();
                  if (invoiceAlreadyExist.length > 0) {
                    this.handleOpenSnackBar(
                      "Invoice Number Entered Already Exist Enter Another!"
                    );
                  } else {
                    if (
                      this.props.match.params.customerId &&
                      selectedCustomerName &&
                      this.state.date &&
                      this.state.invoiceNumber &&
                      this.state.selectedDealsId &&
                      this.state.selectedDealsCount &&
                      this.state.totalBrokerageAmount &&
                      this.state.totalQuantity &&
                      user.uid !== ""
                    ) {
                      const invoice = {
                        customerId: this.props.match.params.customerId,
                        customerName: selectedCustomerName,
                        invoiceDate: this.state.date,
                        invoiceNumber: this.state.invoiceNumber,
                        dealsId: this.state.selectedDealsId,
                        otherPartyId: this.state.otherPartyId,
                        dealsCount: this.state.selectedDealsCount,
                        invoiceAmount: this.state.totalBrokerageAmount,
                        dealsTotalQuantity: this.state.totalQuantity,
                        isPaid: false,
                        description: this.state.description,
                        userId: user.uid,
                        organisationId: organisationId,
                        createdAt: new Date()
                      };
                      generateInvoice(invoice);
                      this.props.history.goBack();
                    } else {
                      this.handleOpenSnackBar(
                        "Please fill Compulsary (Red Mark) Fields before Generating Invoice....!"
                      );
                    }
                  }
                }}
                style={{
                  backgroundColor: primaryShade1,
                  color: "white",
                  width: "100%",
                  height: "100%"
                }}
              >
                GENERATE INVOICE
              </Button>
            </div>
            <Snackbar
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
              }}
              open={this.state.openSnackBar}
              autoHideDuration={3000}
              onClose={this.handleClose}
            >
              <MySnackbarContentWrapper
                variant="warning"
                message={snackbarMessage}
              />
            </Snackbar>
          </div>
        )}
      </Layout>
    );
  }
}
GenerateInvoice.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(stylesMain)(GenerateInvoice));
